import { symbolsJson } from "@corca/data";
import { latexExportsJson } from "@corca/data/latex-exports";

const SYMBOL_MAP: Record<string, string> = {};

for (const symbol of symbolsJson) {
  if (/^[^\x20-\x7F]$/.test(symbol.symbol)) {
    SYMBOL_MAP[symbol.symbol] = latexExportsJson[symbol.key]?.exports ?? "";
  }
}

export function sanitizeNonAscii(str: string) {
  return str.replace(/[^\x20-\x7F]/g, (char: string) => {
    return SYMBOL_MAP[char] ?? char;
  });
}
